import { mockable } from '@datadog/browser-core';
import { reportScriptLoadingError } from '../domain/scriptLoadingError';
export async function lazyLoadProfiler() {
    try {
        return await mockable(importProfiler)();
    }
    catch (error) {
        reportScriptLoadingError({
            error,
            source: 'Profiler',
            scriptType: 'module',
        });
    }
}
export async function importProfiler() {
    const module = await import(/* webpackChunkName: "profiler" */ '../domain/profiling/profiler');
    return module.createRumProfiler;
}
//# sourceMappingURL=lazyLoadProfiler.js.map